/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './RequiredMinimumDistributionCard.scss';
import React from 'react';

import BaseCard from 'components/shared/Card/BaseCard';
import { requiredMinimumDistributionUrl } from 'services/Externals';
import { RMDTile } from '@trp-ii-ii-component-library/ii-components';

const RequiredMinimumDistributionCard = ({
  apiKey,
  asOfDate,
  bpId,
  data,
  isVisible,
  isLoading,
  hasError
}) => {
  const footer = (
    <a
      href={requiredMinimumDistributionUrl()}
      className="card-action-link"
      rel="noopener noreferrer"
      id="view-rmds-link">
      View Details
    </a>
  );

  if (!isVisible || hasError) {
    return null;
  }

  if(!data || !data?.showDashboard){
    return null;
  }

  return (
    <BaseCard
      isLoading={isLoading}
      title="Required Minimum Distribution"
      footer={footer}
      className="standard current-required-minimum-distribution-card-container">
      <div className="current-required-minimum-distribution-card">
        <RMDTile
          title={'Your T. Rowe Price Required Minimum Distribution (RMD)'}
          rmdSummaryData={data}
          includePreRMD={true}
          rmdAsOfDate={asOfDate}
          apiKey={apiKey}
          loggedInBpId={bpId}
        />
      </div>
    </BaseCard>
  );
};

RequiredMinimumDistributionCard.defaultProps = {
  isLoading: false,
  hasError: false
};

export default RequiredMinimumDistributionCard;
